import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from '../api/axios';
import { API_ENDPOINTS } from "../api/endpoint";
import { toast } from "react-toastify";

// Get menu settings (public)
export const getMenuSettings = createAsyncThunk('menuSettings/getMenuSettings', async (_, { rejectWithValue }) => {
    try {
        const response = await axios({
            url: API_ENDPOINTS.GET_MENU_SETTINGS,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Failed to get menu settings:', error);
        return rejectWithValue(error.response?.data || { error: 'Failed to get menu settings' });
    }
});

// Admin: Get all menu settings
export const adminGetMenuSettings = createAsyncThunk('menuSettings/adminGetMenuSettings', async (_, { rejectWithValue }) => {
    try {
        console.log('[MenuSettings] Fetching admin menu settings...');
        const response = await axios({
            url: API_ENDPOINTS.ADMIN_GET_MENU_SETTINGS,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        console.log('[MenuSettings] Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('[MenuSettings] Failed to get admin menu settings:', error);
        console.error('[MenuSettings] Error response:', error.response?.data);
        return rejectWithValue(error.response?.data || { error: 'Failed to get menu settings' });
    }
});

// Admin: Update menu settings
export const adminUpdateMenuSettings = createAsyncThunk('menuSettings/adminUpdateMenuSettings', async (data, { rejectWithValue }) => {
    try {
        const response = await axios({
            url: API_ENDPOINTS.ADMIN_UPDATE_MENU_SETTINGS,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data,
        });
        
        if (response.data.success) {
            toast.success(response.data.message || 'Menu settings updated successfully!');
        }
        
        return response.data;
    } catch (error) {
        console.error('Failed to update menu settings:', error);
        toast.error(error.response?.data?.error || 'Failed to update menu settings');
        return rejectWithValue(error.response?.data || { error: 'Failed to update menu settings' });
    }
});

const initialState = {
    // Public menu settings
    headerMenus: [],
    popupMenus: [],
    settingsMenus: [],
    menusLoading: false,
    menusError: null,
    
    // Admin menu settings
    adminMenus: [],
    adminMenusLoading: false,
    adminMenusError: null,
    updateLoading: false,
};

export const menuSettingsSlice = createSlice({
    name: 'menuSettings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Get menu settings (public)
            .addCase(getMenuSettings.pending, (state) => {
                state.menusLoading = true;
                state.menusError = null;
            })
            .addCase(getMenuSettings.fulfilled, (state, action) => {
                state.menusLoading = false;
                if (action.payload && action.payload.success) {
                    state.headerMenus = action.payload.header || [];
                    state.popupMenus = action.payload.popup || [];
                    state.settingsMenus = action.payload.settings || [];
                }
            })
            .addCase(getMenuSettings.rejected, (state, action) => {
                state.menusLoading = false;
                state.menusError = action.payload?.error || 'Failed to load menu settings';
            })
            
            // Admin: Get all menu settings
            .addCase(adminGetMenuSettings.pending, (state) => {
                state.adminMenusLoading = true;
                state.adminMenusError = null;
            })
            .addCase(adminGetMenuSettings.fulfilled, (state, action) => {
                state.adminMenusLoading = false;
                console.log('[MenuSettings] Fulfilled with payload:', action.payload);
                if (action.payload && action.payload.success) {
                    state.adminMenus = action.payload.menus || [];
                    console.log('[MenuSettings] Set adminMenus to:', state.adminMenus);
                } else {
                    // If success is false, treat it as an error
                    state.adminMenusError = action.payload?.error || 'Unknown error';
                    console.log('[MenuSettings] Error in response:', state.adminMenusError);
                }
            })
            .addCase(adminGetMenuSettings.rejected, (state, action) => {
                state.adminMenusLoading = false;
                state.adminMenusError = action.payload?.error || 'Failed to load menu settings';
                console.log('[MenuSettings] Rejected with error:', state.adminMenusError);
            })
            
            // Admin: Update menu settings
            .addCase(adminUpdateMenuSettings.pending, (state) => {
                state.updateLoading = true;
            })
            .addCase(adminUpdateMenuSettings.fulfilled, (state) => {
                state.updateLoading = false;
            })
            .addCase(adminUpdateMenuSettings.rejected, (state) => {
                state.updateLoading = false;
            });
    }
});

export default menuSettingsSlice.reducer;

